import { render, staticRenderFns } from "./assessmentReview.vue?vue&type=template&id=374f8d21&scoped=true&"
import script from "./assessmentReview.vue?vue&type=script&lang=ts&"
export * from "./assessmentReview.vue?vue&type=script&lang=ts&"
import style0 from "./assessmentReview.vue?vue&type=style&index=0&id=374f8d21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374f8d21",
  null
  
)

export default component.exports